import { channelNames } from './channelNames';
import { subscribeToChannel } from './subscribe';

export function subscribe(callback) {
    const channels = [channelNames.INBOX_MESSAGES, channelNames.PINNED_FLASHES, channelNames.JOB_POST_MATCHED].join(
        ' '
    );

    return subscribeToChannel(channels, callback);
}
